<div class="border-panel">
  <h2 class="header">Hinder - {{ header }}</h2>
  <faxe-chip-list #resultCodes
                  errorType=true
                  [parentFormGroup]="formGroup"
                  formCtrlName="resultCodes"
                  [preSelectedKeys]="preselectedKey"
                  [itemsSet]="resultCodesDataItem"
                  (itemPreSelectedEvent)="onResultPreSelected($event)"
                  (itemSelectedEvent)="resultSelected($event)"
                  (itemUnSelectedEvent)="onUnSeleted($event)"
                  (lastItemUnSelectedEvent)="onLastUnSelected($event)"
  ></faxe-chip-list>

  <button
    type="button"
    mat-raised-button
    color="primary"
    class="wide"
    (click)="onReportClick()"
    [disabled]="!anyResultCodeSelected || reported">
    Rapportera
  </button>

</div>
